module.exports = __webpack_public_path__ + "media/images/game_icon/zh-tw/VGSEAFOOD2-09e2c613b83d3980b38d4dee6dce3ac1.png";